import React from 'react'
import PvInvertersTable from './PvInvertersTable'
import usePvInverterList from 'src/Libs/solar/hooks/use-pv-inverter-list'
import CollapsedPaper from './CollapsedPaper'
import { ErrorMessage } from '@e3dc-react/shell/Elements/Error'
import { Loading } from '@e3dc-react/shell/Elements/Loading'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface PvInvertersProps {
  storageId?: string
}

/**
 * Wrapper Component for PV Inverters tile in system components view
 */
const PvInverters: React.FC<PvInvertersProps> = ({ storageId }) => {
  const { t } = useCustomTranslation()
  const [pvInverters, isLoading, isError] = usePvInverterList(storageId)

  return (
    <CollapsedPaper title={t('system-details.components.pv-inverters.title')}>
      {isError ? (
        <ErrorMessage title={t('system-details.components.pv-inverters.error')} />
      ) : isLoading ? (
        <Loading />
      ) : (
        <PvInvertersTable pvInverters={pvInverters ?? []} />
      )}
    </CollapsedPaper>
  )
}

export default PvInverters
